import './Main.css'

import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Spinner } from '@/components/spinner';
import { useAppContext } from '@/context/app';
import { MachineWorkingDaysReportWizardStep1 } from './Step1';
import { cleanWizardData, WizardData } from './Model';
import { useWizard, WizardProvider } from '@/common/wizard/wizard';
import { UseFormReturn } from 'react-hook-form';
import { addServerErrors } from '@/components/forms/common/FormBase';
import { MachineWorkingDaysReportWizardResult } from './Result';

const maxStep = 2

export const MachineWorkingDaysReportWizardBody = ({ onDone }: {
  onDone: (id: string) => void
}) => {
  // const {services, session, translates} = useAppContext()
  const { step} = useWizard()

  if (step === 0) {
    return <MachineWorkingDaysReportWizardStep1  />
  } else if (step === 1) {
    return <MachineWorkingDaysReportWizardResult />
  } else return <Spinner />
}

export const MachineWorkingDaysReportWizard = ({ onDone }: {
  onDone: (id: string) => void
}) => {
  return <div className='machineworkingdays-wizard'>
    <WizardProvider<WizardData> initialData={cleanWizardData()} maxStep={maxStep}>
      <MachineWorkingDaysReportWizardBody onDone={onDone} />
    </WizardProvider>
  </div>
}

export const MachineWorkingDaysReportWizardPopup = ({ onClose }: {
  onClose: () => void
}) => {
  return <MachineWorkingDaysReportWizard onDone={onClose} />
}
